<script setup>
import { computed } from 'vue'
import { useODataSource } from '@/composables/data-grid'
import { useRegistryStore } from '@/stores/registry.store'
import { menuRoutesEnum } from '@/router'

import GridDropDownBox from '@/components/shared/GridDropDownBox.vue'
import { usePortalStore } from '@/stores/portal.store'

const emit = defineEmits({
  valueChanged: (e) => true,
})
const props = defineProps({
  data: {
    type: Object,
    default: null,
  },
  showClearButton: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  customer: {
    type: Object,
    default: null,
  }
})

const registryStore = useRegistryStore()
const portalStore = usePortalStore()

const computedDefaultDataSource = computed(() => {
  const customer = props.customer?.subject_id || props.customer?.subject
  const filters = [['contact_type', '=', portalStore.subjectContactTypes.DELIVERY_ADDRESS]]

  if (customer) { filters.push(['customer', '=', customer]) }
  return useODataSource(registryStore.api.getAbsoluteUrl() + registryStore.api.subjectContactsSearchUrl, {
    filter: filters,
    searchExpr: ['name', 'code'],
  })
})

const valueChanged = (e) => {
  emit('valueChanged', { value: e })
  props.data?.setValue(e)
}
</script>

<template>
  <grid-drop-down-box
    :disabled="props.disabled"
    :value="props.data.value?.id ?? props.data.value"
    :data-source="computedDefaultDataSource"
    :show-clear-button="props.showClearButton"
    :columns="[
      { dataField: 'code', caption: $t('common.code'), width: '5rem' },
      {
        dataField: 'name', caption: $t('common.name'),
        calculateDisplayValue: (rowData) => {
          let name = rowData.name
          if (rowData.name_ext) { name += ` ${rowData.name_ext}` }
          return name
        },
        sortOrder: 'asc',
      },
      { dataField: 'address.country_name', caption: $t('common.country') },
      { dataField: 'address.state_name', caption: $t('common.state') },
      { dataField: 'address.city_name', caption: $t('common.city') },
      { dataField: 'address.street', caption: $t('common.street') },
    ]"
    :drop-down-options="{ width: '56rem', height: '15rem' }"
    :options="{ target: menuRoutesEnum.SUBJECTS, routeParam: props.data.data?.customer?.code }"
    @value-changed="valueChanged"
  />
</template>
